import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ItemSelectModal from "../common/ItemSelectModal";
import UserSelectModal from "../common/UserSelectModal";
import WorkplaceSelectModal from "../common/WorkplaceSelectModal";
import WarehouseSelectModal from "../common/WarehouseSelectModal";
import WarehouseSectionSelectModal from "../common/WarehouseSectionSelectModal";
import Moment from 'moment';
import "moment/locale/ko";

let newFileID = 1;
let realFiles = [];
function StockAdjustmentRegModal({ title, onClose, handleRegSuccessSave, typeModalOption, MenuUpdateYN}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [itemRows, setItemRows] = useState([]);
  const [updateItemRows, setUpdateItemRows] = useState([]);
  const [itemColumns, setItemColumns] = useState([]);
  const [lotRows, setLotRows] = useState([]);
  const [updateLotRows, setUpdateLotRows] = useState([]);
  const [lotColumns, setLotColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    stock_adjustment_id: null,
    stock_adjustment_number: '',
    stock_adjustment_type: '',
    stock_adjustment_date: appStore.YYYY_MM_DD(),
    stock_adjustment_approval_user_id: null,
    stock_adjustment_approval_user_name: '',
    stock_adjustment_reason: ''
  });
  const [lotNoStartNumber, setLotNoStartNumber] = useState('1');
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectItemModalOpen, setSelectItemModalOpen] = useState(false);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [isSelectWorkplaceModalOpen, setSelectWorkplaceModalOpen] = useState(false);
  const [isSelectWarehouseModalOpen, setSelectWarehouseModalOpen] = useState(false);
  const [isSelectWarehouseSectionModalOpen, setSelectWarehouseSectionModalOpen] = useState(false);
  const [selectItemData, setSelectItemData] = useState('');
  const [selectLotData, setSelectLotData] = useState('');
  const [selectModalType, setSelectModalType] = useState('');
  const [upperWorkplaceId, setUpperWorkplaceId] = useState(0);
  const [upperWarehouseId, setUpperWarehouseId] = useState(0);

  const handleSetting = () => {
    setItemColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {itemAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'stock_adjustment_item_id', headerName: 'stock_adjustment_item_id', headerAlign: 'center', align:'center' },
      { field: 'stock_adjustment_item_name', headerName: '품목', width: 150, headerAlign: 'center', align:'left' },
      { field: 'stock_adjustment_item_spec', headerName: '규격', width: 230, headerAlign: 'center', align:'left' },
      { field: 'stock_adjustment_item_b_stock', headerName: '변경 전 재고', type: 'number', width: 100, headerAlign: 'center', align:'right' },
      { field: 'stock_adjustment_item_a_stock', headerName: '변경 후 재고', type: 'number', width: 100, headerAlign: 'center', align:'right', editable: true },
      { field: 'stock_adjustment_item_count', headerName: 'stock_adjustment_item_count', type: 'number', width: 0, headerAlign: 'center' },
      { field: 'stock_adjustment_save_workplace_id', headerName: 'stock_adjustment_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'stock_adjustment_save_warehouse_id', headerName: 'stock_adjustment_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'stock_adjustment_save_section_id', headerName: 'stock_adjustment_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'stock_adjustment_save_workplace_name', headerName: 'stock_adjustment_save_workplace_name',width: 0, headerAlign: 'center'},
      { field: 'stock_adjustment_save_warehouse_name', headerName: 'stock_adjustment_save_warehouse_name', width: 0, headerAlign: 'center' },
      { field: 'stock_adjustment_save_section_name', headerName: 'stock_adjustment_save_section_name',width: 0, headerAlign: 'center'},
      { field: 'stock_adjustment_item_reason', headerName: '조정 사유', width: 260, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setLotColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 160, headerAlign: 'center', align:'center' },
      { field: 'lot_stock_adjustment_item_lot_type', headerName: 'lot_stock_adjustment_item_lot_type',width: 0, headerAlign: 'center'},
      { field: 'lot_stock_adjustment_item_lot_type_name', headerName: '구분', width: 70, headerAlign: 'center', align:'center' },
      { field: 'lot_stock_adjustment_item_id', headerName: 'lot_stock_adjustment_item_id', headerAlign: 'center', align:'center' },
      { field: 'lot_stock_adjustment_item_name', headerName: '품목', width: 150, headerAlign: 'center', align:'left' },
      { field: 'lot_stock_adjustment_item_spec', headerName: '규격', width: 170, headerAlign: 'center', align:'left' },
      { field: 'lot_stock_adjustment_save_workplace_id', headerName: 'lot_incoming_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_stock_adjustment_save_workplace_name', headerName: '사업장',width: 100, headerAlign: 'center'},
      { field: 'lot_stock_adjustment_save_warehouse_id', headerName: 'lot_incoming_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_stock_adjustment_save_warehouse_name', headerName: '창고', width: 100, headerAlign: 'center', align:'left' },
      { field: 'lot_stock_adjustment_save_section_id', headerName: 'lot_incoming_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_stock_adjustment_save_section_name', headerName: '구역',width: 100, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setItemColumnVisibilityModel({
      id: false,
      actions: true,
      stock_adjustment_item_id: false,
      stock_adjustment_item_name: true,
      stock_adjustment_item_spec: true,
      stock_adjustment_item_b_stock: true,
      stock_adjustment_item_a_stock: true,
      stock_adjustment_item_count: false,
      stock_adjustment_save_workplace_id: false,
      stock_adjustment_save_warehouse_id: false,
      stock_adjustment_save_section_id: false,
      stock_adjustment_save_workplace_name: false,
      stock_adjustment_save_warehouse_name: false,
      stock_adjustment_save_section_name: false,
      stock_adjustment_item_reason: true,
      row_type: false,
      update_type: false
    });

    setLotColumnVisibilityModel({
      id: false,
      upper_id: false,
      lot_no: true,
      lot_stock_adjustment_item_lot_type: false,
      lot_stock_adjustment_item_lot_type_name: true,
      lot_stock_adjustment_item_id: false,
      lot_stock_adjustment_item_name: true,
      lot_stock_adjustment_item_spec: true,
      lot_stock_adjustment_save_workplace_id: false,
      lot_stock_adjustment_save_workplace_name: true,
      lot_stock_adjustment_save_warehouse_id: false,
      lot_stock_adjustment_save_warehouse_name: true,
      lot_stock_adjustment_save_section_id: false,
      lot_stock_adjustment_save_section_name: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: true,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    stock_adjustment_item_id: false,
    stock_adjustment_item_name: true,
    stock_adjustment_item_spec: true,
    stock_adjustment_item_b_stock: true,
    stock_adjustment_item_a_stock: true,
    stock_adjustment_item_count: false,
    stock_adjustment_save_workplace_id: false,
    stock_adjustment_save_warehouse_id: false,
    stock_adjustment_save_section_id: false,
    stock_adjustment_save_workplace_name: false,
    stock_adjustment_save_warehouse_name: false,
    stock_adjustment_save_section_name: false,
    stock_adjustment_item_reason: true,
    row_type: false,
    update_type: false
  });

  const [lotColumnVisibilityModel, setLotColumnVisibilityModel] = useState({
    id: false,
    upper_id: false,
    lot_no: true,
    lot_stock_adjustment_item_lot_type: false,
    lot_stock_adjustment_item_lot_type_name: true,
    lot_stock_adjustment_item_id: false,
    lot_stock_adjustment_item_name: true,
    lot_stock_adjustment_item_spec: true,
    lot_stock_adjustment_save_workplace_id: false,
    lot_stock_adjustment_save_workplace_name: true,
    lot_stock_adjustment_save_warehouse_id: false,
    lot_stock_adjustment_save_warehouse_name: true,
    lot_stock_adjustment_save_section_id: false,
    lot_stock_adjustment_save_section_name: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: true,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    //Lot날짜 설정
    axios.get('/api/Common/LotNoStartNumber',
      {
        params : {
          type: 'S',
          date: inputs.stock_adjustment_date
        }
      },
      { withCredentials: true }
    )
    .then((response) => { 
      setLotNoStartNumber(response.data);
      createLotRow(itemRows, {}, 'A', inputs.stock_adjustment_date, response.data);
    })
    .catch((error) => {
        console.log(error);
    });
  }, [inputs.stock_adjustment_date]);

  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<itemRows.length; i++){
      if(itemRows[i].row_type === 'A' && itemRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        stock_adjustment_item_id: '',
        stock_adjustment_item_name: '',
        stock_adjustment_item_spec: '',
        stock_adjustment_item_b_stock: '',
        stock_adjustment_item_a_stock: '',
        stock_adjustment_item_count: '',
        stock_adjustment_save_workplace_id: null,
        stock_adjustment_save_warehouse_id: null,
        stock_adjustment_save_section_id: null,
        stock_adjustment_save_workplace_name: '',
        stock_adjustment_save_warehouse_name: '',
        stock_adjustment_save_section_name: '',
        stock_adjustment_item_reason: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [itemRows]);
  
  useEffect(() => {
    let ADD_YN= 'Y'
    var array = [];
    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){
        array.push({
          id: newFileID,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_name: tmp_file_name,
          file_type_name: tmp_file_type_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_reg_user_name,
          reg_datetime: tmp_reg_datetime,
          row_type:tmp_row_type,
          update_type: tmp_update_type
        })
        newFileID = newFileID + 1;
      }
    }
    setUpdateFileRows(array);
    
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }
    
    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(appStore.getMaxListID(fileRows))+1,
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onClick = (e)=>{ // inputs 데이터 품목 text 클릭시
    
    setSelectModalTitle('재고조정승인자 목록')
    setSelectUserModalOpen(true);

  };

  const onSelectChange = (type, value) => {
    const nextInputs = {
        ...inputs,
        [type] : value
    };
    setInputs(nextInputs);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onDateChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
    createLotRow(itemRows, [{id:0}], 'A', e.target.value); // 재고조정정보 날짜 변경 시 lot 임시번호 갱신
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processItemRowUpdate = (newRow, oldRow) => {
    // 재고조정 품목 Rows Update
    // 날짜형식 fomat 맞춰주기
    let newUpdateDataArray = { 
        ...newRow
        , update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; // 값 변경이 없는 경우
    
    if(newRow.stock_adjustment_item_id !== oldRow.stock_adjustment_item_id || newRow.stock_adjustment_item_name !== oldRow.stock_adjustment_item_name || newRow.stock_adjustment_item_a_stock !== oldRow.stock_adjustment_item_a_stock || newRow.stock_adjustment_item_reason !== oldRow.stock_adjustment_item_reason){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_stock_adjustment_item_id = '';
      var row_stock_adjustment_item_name = '';
      var row_stock_adjustment_item_a_stock = '';
      var row_stock_adjustment_item_b_stock = '';
      var row_stock_adjustment_item_reason = '';

      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.stock_adjustment_item_id !== '' || newRow.stock_adjustment_item_name !== '' || newRow.stock_adjustment_item_a_stock !== '' || newRow.stock_adjustment_item_reason !== ''){
          row_stock_adjustment_item_id = newRow.stock_adjustment_item_id;
          row_stock_adjustment_item_name = newRow.stock_adjustment_item_name;
          row_stock_adjustment_item_a_stock = newRow.stock_adjustment_item_a_stock;
          row_stock_adjustment_item_b_stock = newRow.stock_adjustment_item_b_stock;
          row_stock_adjustment_item_reason = newRow.stock_adjustment_item_reason;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        itemRows.map((data) => data.id === newRow.id 
          && (data.stock_adjustment_item_id !== newRow.stock_adjustment_item_id || data.stock_adjustment_item_name !== newRow.stock_adjustment_item_name || data.stock_adjustment_item_a_stock !== newRow.stock_adjustment_item_a_stock || data.stock_adjustment_item_reason !== newRow.stock_adjustment_item_reason)?
          (
            row_stock_adjustment_item_id = data.stock_adjustment_item_id,
            row_stock_adjustment_item_name = data.stock_adjustment_item_name,
            row_stock_adjustment_item_a_stock = data.stock_adjustment_item_a_stock,
            row_stock_adjustment_item_b_stock = data.stock_adjustment_item_b_stock,
            row_stock_adjustment_item_reason = data.stock_adjustment_item_reason
          ):""
        )
      }
      
      if(row_stock_adjustment_item_id === '' && row_stock_adjustment_item_name === '' && row_stock_adjustment_item_a_stock === '' && row_stock_adjustment_item_reason === ''){
        // 1. 값이 수정되지 않은 경우.
        if(updateItemRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateItemRows.length);
          setUpdateItemRows(updateItemRows.filter((data) => data.id !== newRow.id));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
          createLotRow(itemRows, newNoDataArray, 'A', inputs.stock_adjustment_date);
          searchLotRow(newNoDataArray, 'O');
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateItemRows.length; i++) {
          if(updateItemRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          } 
        }

        if(newRow.stock_adjustment_item_a_stock !== ''){
          newUpdateDataArray = { ...newRow, stock_adjustment_item_count: (Number(newRow.stock_adjustment_item_a_stock) - Number(newRow.stock_adjustment_item_b_stock)), update_type: 'U' }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateItemRows.length);
          setUpdateItemRows(updateItemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          createLotRow(itemRows, newUpdateDataArray, 'A', inputs.stock_adjustment_date)
          searchLotRow(newUpdateDataArray, 'A');
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateItemRows.length);
          setUpdateItemRows(prevRows => [...prevRows, newUpdateDataArray]);
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          createLotRow(itemRows, newUpdateDataArray, 'A', inputs.stock_adjustment_date);
          searchLotRow(newUpdateDataArray, 'A');
        }
        
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  // item row 업데이트와 동시에 lot row 생성
  const createLotRow = (tempItemRow, tempNewUpdateData, tempType, changeDate, startNumber='0') => { // LotNo 탭 생성함수
    if(tempType === 'D'){ // 삭제로직시

      setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));

    } else { // 일반 추가 or 업데이트
      setLotRows((lotRows) => lotRows.filter((data) => (data.lot_stock_adjustment_item_lot_type === 'D' && data.upper_id !== tempNewUpdateData.id)));
      setUpdateLotRows((updateLotRows) => updateLotRows.filter((data) => (data.lot_stock_adjustment_item_lot_type === 'D' && data.upper_id !== tempNewUpdateData.id)));

      //setLotRows([]);// 초기화 // 항상 다 지우고 다시 만듦
      //setUpdateLotRows([]);// 초기화 // 항상 다 지우고 다시 만듦
      
      var now_lot_date_count = lotNoStartNumber;
      if(startNumber !== '0'){
        now_lot_date_count = startNumber;
      }

      if(tempItemRow.length > 0){ // 재고조정품목 실질 update 데이터에서 Lotno data  이관
        var now_lot_no_count = '1';
        for(let i = 0; i < tempItemRow.length; i++) {
          if(tempItemRow[i].stock_adjustment_item_id !== 0 && tempItemRow[i].stock_adjustment_item_id !== '' && Number(tempItemRow[i].stock_adjustment_item_a_stock) > Number(tempItemRow[i].stock_adjustment_item_b_stock)){ // 품목을 선택했을시에만 lot grid에 insert

            if (tempItemRow[i].id === tempNewUpdateData.id) { // 이번업데이트 데이터 반영
              now_lot_no_count = settingLotRows(tempNewUpdateData, now_lot_date_count, now_lot_no_count, changeDate);
            } else { // 기존 데이터 반영
              now_lot_no_count = settingLotRows(tempItemRow[i], now_lot_date_count, now_lot_no_count, changeDate);
            }

          } else { // 품목 선택 안하면 lot grid 에 데이터 넣지 않음 

            if (tempItemRow[i].id === tempNewUpdateData.id) { // 이번업데이트 데이터 반영
              now_lot_no_count = settingLotRows(tempNewUpdateData, now_lot_date_count, now_lot_no_count, changeDate);
            }
          }
        }
      }
    }
  }

  const settingLotRows = (insertData, now_lot_date_count, now_lot_no_count, changeDate) => { //lot grid 데이터 넣어주는 함수
    
    const stock_adjustment_item_id = insertData.stock_adjustment_item_id;
    const stock_adjustment_item_name = insertData.stock_adjustment_item_name;
    const stock_adjustment_item_spec = insertData.stock_adjustment_item_spec;
    const stock_adjustment_item_b_stock = insertData.stock_adjustment_item_b_stock;
    const stock_adjustment_item_a_stock = insertData.stock_adjustment_item_a_stock;
    const stock_adjustment_item_count = (Number(insertData.stock_adjustment_item_a_stock) - Number(insertData.stock_adjustment_item_b_stock));
    const stock_adjustment_save_workplace_id = insertData.stock_adjustment_save_workplace_id;
    const stock_adjustment_save_warehouse_id = insertData.stock_adjustment_save_warehouse_id;
    const stock_adjustment_save_section_id = insertData.stock_adjustment_save_section_id;
    const stock_adjustment_save_workplace_name = insertData.stock_adjustment_save_workplace_name;
    const stock_adjustment_save_warehouse_name = insertData.stock_adjustment_save_warehouse_name;
    const stock_adjustment_save_section_name = insertData.stock_adjustment_save_section_name;
    const stock_adjustment_item_reason = insertData.stock_adjustment_item_reason;
    const row_type = insertData.row_type;
    const update_type = insertData.update_type;

    var return_data = now_lot_no_count;
    for(let i = Number(now_lot_no_count); i < (Number(stock_adjustment_item_count)+Number(now_lot_no_count)); i++) {
      if(stock_adjustment_item_id !== '' && stock_adjustment_item_id !== 0){
        const tempDate = now_lot_date_count.toString().padStart(3,'0');
        const tempNo = i.toString().padStart(5,'0');
        const tempLotNo =  'S'+(Moment(changeDate).format("YYMMDD"))+tempDate+'-'+tempNo; // 임시 lot번호

        setLotRows((lotRows) => [...lotRows, { 
          id: Number(appStore.getMaxListID(lotRows))+1,
          upper_id: insertData.id,
          lot_no: tempLotNo,
          lot_stock_adjustment_item_lot_type: 'C',
          lot_stock_adjustment_item_lot_type_name: '생성',
          lot_stock_adjustment_item_id: stock_adjustment_item_id,
          lot_stock_adjustment_item_name: stock_adjustment_item_name,
          lot_stock_adjustment_item_spec: stock_adjustment_item_spec,
          lot_stock_adjustment_save_workplace_id: stock_adjustment_save_workplace_id,
          lot_stock_adjustment_save_warehouse_id: stock_adjustment_save_warehouse_id,
          lot_stock_adjustment_save_section_id: stock_adjustment_save_section_id,
          lot_stock_adjustment_save_workplace_name: stock_adjustment_save_workplace_name,
          lot_stock_adjustment_save_warehouse_name: stock_adjustment_save_warehouse_name,
          lot_stock_adjustment_save_section_name: stock_adjustment_save_section_name,
          row_type:row_type,
          update_type: update_type
        }]);

        setUpdateLotRows((lotRows) => [...lotRows, { 
          id: Number(appStore.getMaxListID(lotRows))+1,
          upper_id: insertData.id,
          lot_no: tempLotNo,
          lot_stock_adjustment_item_lot_type: 'C',
          lot_stock_adjustment_item_lot_type_name: '생성',
          lot_stock_adjustment_item_id: stock_adjustment_item_id,
          lot_stock_adjustment_item_name: stock_adjustment_item_name,
          lot_stock_adjustment_item_spec: stock_adjustment_item_spec,
          lot_stock_adjustment_save_workplace_id: stock_adjustment_save_workplace_id,
          lot_stock_adjustment_save_warehouse_id: stock_adjustment_save_warehouse_id,
          lot_stock_adjustment_save_section_id: stock_adjustment_save_section_id,
          lot_stock_adjustment_save_workplace_name: stock_adjustment_save_workplace_name,
          lot_stock_adjustment_save_warehouse_name: stock_adjustment_save_warehouse_name,
          lot_stock_adjustment_save_section_name: stock_adjustment_save_section_name,
          row_type:row_type,
          update_type: update_type
        }]);
        return_data = (i+1);
      }
    }
    return return_data;
  };

  const searchLotRow = (tempNewUpdateData, tempType, startCount = 0) => { 
    
    if(tempNewUpdateData.stock_adjustment_item_a_stock === null || tempNewUpdateData.stock_adjustment_item_a_stock === ''){
      tempNewUpdateData.stock_adjustment_item_a_stock = tempNewUpdateData.stock_adjustment_item_b_stock
      tempType = 'D'
    }

    if(tempType === 'D'){ // 삭제인 경우 'D'

      setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows((updateLotRows) => updateLotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));

    } else if(tempType === 'O'){ // 신규와 동일한 경우 'O'

      setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows((updateLotRows) => updateLotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));

    } else if(tempType === 'A'){ // 업데이트 'A'
      if(tempNewUpdateData.stock_adjustment_item_a_stock !== '' && tempNewUpdateData.stock_adjustment_item_b_stock !== '' && Number(tempNewUpdateData.stock_adjustment_item_a_stock) < Number(tempNewUpdateData.stock_adjustment_item_b_stock)){
        var stock_adjustment_item_count = (Number(tempNewUpdateData.stock_adjustment_item_b_stock) - Number(tempNewUpdateData.stock_adjustment_item_a_stock));
        
        if(Number(stock_adjustment_item_count) > 0){
        // 품목 정보가 변경되었을때 (Item 재고 조회)
          setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
          setUpdateLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
          
          axios.get('/api/Common/StockFIFOInfo',
              {
              params : {
                  item_id : tempNewUpdateData.stock_adjustment_item_id,
                  item_count: stock_adjustment_item_count
              }
            },
            { withCredentials: true }
          )
          .then((response) => {
            var start_lot_id = Number(appStore.getMaxListID(lotRows))+1+startCount;
            var create_lot_array = [];
            var lot_array = response.data;
            // Limit이 걸려져있어서 length와 item_count가 동일함.
            if(lot_array.length >= Number(stock_adjustment_item_count)){
              for(var i=0; i<Number(stock_adjustment_item_count); i++){
                create_lot_array.push(
                  {
                    id: (start_lot_id+i),
                    upper_id: tempNewUpdateData.id,
                    lot_no: lot_array[i].item_lotno,
                    lot_stock_adjustment_item_lot_type: 'D',
                    lot_stock_adjustment_item_lot_type_name: '소멸',
                    lot_stock_adjustment_item_id: tempNewUpdateData.stock_adjustment_item_id,
                    lot_stock_adjustment_item_name: tempNewUpdateData.stock_adjustment_item_name,
                    lot_stock_adjustment_item_spec: tempNewUpdateData.stock_adjustment_item_spec,
                    lot_stock_adjustment_save_workplace_id: (typeof lot_array[i].item_lot_save_workplace_id === 'undefined'?null:lot_array[i].item_lot_save_workplace_id),
                    lot_stock_adjustment_save_workplace_name: (typeof lot_array[i].item_lot_save_workplace_name === 'undefined'?null:lot_array[i].item_lot_save_workplace_name),
                    lot_stock_adjustment_save_warehouse_id: (typeof lot_array[i].item_lot_save_warehouse_id === 'undefined'?null:lot_array[i].item_lot_save_warehouse_id),
                    lot_stock_adjustment_save_warehouse_name: (typeof lot_array[i].item_lot_save_warehouse_name === 'undefined'?null:lot_array[i].item_lot_save_warehouse_name),
                    lot_stock_adjustment_save_section_id: (typeof lot_array[i].item_lot_save_section_id === 'undefined'?null:lot_array[i].item_lot_save_section_id),
                    lot_stock_adjustment_save_section_name: (typeof lot_array[i].item_lot_save_section_name === 'undefined'?null:lot_array[i].item_lot_save_section_name),
                    row_type: 'A',
                    update_type: 'U'
                  }
                )
              }
              setLotRows((lotRows) => [...lotRows, ...create_lot_array ]);
              setUpdateLotRows((updateLotRows) => [...updateLotRows, ...create_lot_array ]);
            }else{
              Swal.fire({
                title: '<p style="color:red">재고조정 품목 재고 부족</p>',
                text: '품목의 가용 재고가 ' + (String(lot_array.length)).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' 입니다.',
                confirmButtonText: '확인'
              });
              
              processItemRowUpdate(
                {
                  id: tempNewUpdateData.id,
                  stock_adjustment_item_id: tempNewUpdateData.stock_adjustment_item_id,
                  stock_adjustment_item_name: tempNewUpdateData.stock_adjustment_item_name,
                  stock_adjustment_item_spec: tempNewUpdateData.stock_adjustment_item_spec,
                  stock_adjustment_item_count: tempNewUpdateData.stock_adjustment_item_count,
                  stock_adjustment_item_b_stock: tempNewUpdateData.stock_adjustment_item_b_stock,
                  stock_adjustment_item_a_stock: '',
                  stock_adjustment_save_workplace_id: tempNewUpdateData.stock_adjustment_save_workplace_id,
                  stock_adjustment_save_warehouse_id: tempNewUpdateData.stock_adjustment_save_warehouse_id,
                  stock_adjustment_save_section_id: tempNewUpdateData.stock_adjustment_save_section_id,
                  stock_adjustment_save_workplace_name: tempNewUpdateData.stock_adjustment_save_workplace_name,
                  stock_adjustment_save_warehouse_name: tempNewUpdateData.stock_adjustment_save_warehouse_name,
                  stock_adjustment_save_section_name: tempNewUpdateData.stock_adjustment_save_section_name,
                  stock_adjustment_item_reason: tempNewUpdateData.stock_adjustment_item_reason,
                  row_type:tempNewUpdateData.row_type,
                  update_type: tempNewUpdateData.update_type
                },
                {
                  id: tempNewUpdateData.id,
                  stock_adjustment_item_id: tempNewUpdateData.stock_adjustment_item_id,
                  stock_adjustment_item_name: tempNewUpdateData.stock_adjustment_item_name,
                  stock_adjustment_item_spec: tempNewUpdateData.stock_adjustment_item_spec,
                  stock_adjustment_item_count: tempNewUpdateData.stock_adjustment_item_count,
                  stock_adjustment_item_b_stock: tempNewUpdateData.stock_adjustment_item_b_stock,
                  stock_adjustment_item_a_stock: tempNewUpdateData.stock_adjustment_item_a_stock,
                  stock_adjustment_save_workplace_id: tempNewUpdateData.stock_adjustment_save_workplace_id,
                  stock_adjustment_save_warehouse_id: tempNewUpdateData.stock_adjustment_save_warehouse_id,
                  stock_adjustment_save_section_id: tempNewUpdateData.stock_adjustment_save_section_id,
                  stock_adjustment_save_workplace_name: tempNewUpdateData.stock_adjustment_save_workplace_name,
                  stock_adjustment_save_warehouse_name: tempNewUpdateData.stock_adjustment_save_warehouse_name,
                  stock_adjustment_save_section_name: tempNewUpdateData.stock_adjustment_save_section_name,
                  stock_adjustment_item_reason: tempNewUpdateData.stock_adjustment_item_reason,
                  row_type:tempNewUpdateData.row_type,
                  update_type: tempNewUpdateData.update_type
                }
              )
              return false;
            }
          });
        }
      }
    }
    return true;
  };

  const processLotRowUpdate = (newRow, oldRow) => {
    // 재고조정 Lot Rows Update

    // 날짜형식 fomat 맞춰주기
    const newUpdateDataArray = { 
        ...newRow
        , update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; // 값 변경이 없는 경우
    
    if(newRow.lot_stock_adjustment_save_workplace_id !== oldRow.lot_stock_adjustment_save_workplace_id || newRow.lot_stock_adjustment_save_warehouse_id !== oldRow.lot_stock_adjustment_save_warehouse_id || newRow.lot_stock_adjustment_save_section_id !== oldRow.lot_stock_adjustment_save_section_id){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_upper_id = 0;
      var row_lot_stock_adjustment_item_id = '';
      var row_lot_stock_adjustment_item_name = '';
      var row_lot_stock_adjustment_save_workplace_id = null
      var row_lot_stock_adjustment_save_workplace_name = '';
      var row_lot_stock_adjustment_save_warehouse_id = null;
      var row_lot_stock_adjustment_save_warehouse_name = '';
      var row_lot_stock_adjustment_save_section_id = null;
      var row_lot_stock_adjustment_save_section_name = '';

      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.lot_stock_adjustment_save_workplace_id !== null|| newRow.lot_stock_adjustment_save_workplace_name !== ''
          || newRow.lot_stock_adjustment_save_warehouse_id !== null || newRow.lot_stock_adjustment_save_warehouse_name !== ''
          || newRow.lot_stock_adjustment_save_section_id !== null || newRow.lot_stock_adjustment_save_section_name !== ''){
          row_upper_id = newRow.upper_id;
          row_lot_stock_adjustment_item_id = newRow.lot_stock_adjustment_item_id;
          row_lot_stock_adjustment_item_name = newRow.lot_stock_adjustment_item_name;
          row_lot_stock_adjustment_save_workplace_id = newRow.lot_stock_adjustment_save_workplace_id;
          row_lot_stock_adjustment_save_workplace_name = newRow.lot_stock_adjustment_save_workplace_name;
          row_lot_stock_adjustment_save_warehouse_id = newRow.lot_stock_adjustment_save_warehouse_id;
          row_lot_stock_adjustment_save_warehouse_name = newRow.lot_stock_adjustment_save_warehouse_name;
          row_lot_stock_adjustment_save_section_id = newRow.lot_stock_adjustment_save_section_id;
          row_lot_stock_adjustment_save_section_name = newRow.lot_stock_adjustment_save_section_name;
        
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        lotRows.map((data) => data.id === newRow.id 
          && (data.lot_stock_adjustment_item_id !== newRow.lot_stock_adjustment_item_id
            || data.lot_stock_adjustment_save_workplace_id !== newRow.lot_stock_adjustment_save_workplace_id
            || data.lot_stock_adjustment_save_warehouse_id !== newRow.lot_stock_adjustment_save_warehouse_id
            || data.lot_stock_adjustment_save_section_id !== newRow.lot_stock_adjustment_save_section_id )?
          (
            row_upper_id = data.upper_id,
            row_lot_stock_adjustment_item_id = data.lot_stock_adjustment_item_id,
            row_lot_stock_adjustment_item_name = data.lot_stock_adjustment_item_name,
            row_lot_stock_adjustment_save_workplace_id = data.lot_stock_adjustment_save_workplace_id,
            row_lot_stock_adjustment_save_workplace_name = data.lot_stock_adjustment_save_workplace_name,
            row_lot_stock_adjustment_save_warehouse_id = data.lot_stock_adjustment_save_warehouse_id,
            row_lot_stock_adjustment_save_warehouse_name = data.lot_stock_adjustment_save_warehouse_name,
            row_lot_stock_adjustment_save_section_id = data.lot_stock_adjustment_save_section_id,
            row_lot_stock_adjustment_save_section_name = data.lot_stock_adjustment_save_section_name
          ):""
        )
      }
      
      if(row_lot_stock_adjustment_save_workplace_id === null && row_lot_stock_adjustment_save_warehouse_id === null && row_lot_stock_adjustment_save_section_id === null){
        // 1. 값이 수정되지 않은 경우.
        if(updateLotRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateLotRows.length);
          setUpdateLotRows(updateLotRows.filter((data) => data.id !== newRow.id));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateLotRows.length; i++) {
          if(updateLotRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateLotRows.length);
          setUpdateLotRows(updateLotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateLotRows.length);
          setUpdateLotRows(prevRows => [...prevRows, newUpdateDataArray]);
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };
  
  const itemAddClick = (object) => {
    //재고조정 품목 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        stock_adjustment_item_id: '',
        stock_adjustment_item_name: '',
        stock_adjustment_item_spec: '',
        stock_adjustment_item_b_stock: '',
        stock_adjustment_item_a_stock: '',
        stock_adjustment_item_count: '',
        stock_adjustment_save_workplace_id: null,
        stock_adjustment_save_warehouse_id: null,
        stock_adjustment_save_section_id: null,
        stock_adjustment_save_workplace_name: '',
        stock_adjustment_save_warehouse_name: '',
        stock_adjustment_save_section_name: '',
        stock_adjustment_item_reason: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: object.row.id,
        stock_adjustment_item_id: object.row.stock_adjustment_item_id,
        stock_adjustment_item_name: object.row.stock_adjustment_item_name,
        stock_adjustment_item_spec: object.row.stock_adjustment_item_spec,
        stock_adjustment_item_b_stock: object.row.stock_adjustment_item_b_stock,
        stock_adjustment_item_a_stock: object.row.stock_adjustment_item_a_stock,
        stock_adjustment_item_count: object.row.stock_adjustment_item_count,
        stock_adjustment_save_workplace_id: object.row.stock_adjustment_save_workplace_id,
        stock_adjustment_save_warehouse_id: object.row.stock_adjustment_save_warehouse_id,
        stock_adjustment_save_section_id: object.row.stock_adjustment_save_section_id,
        stock_adjustment_save_workplace_name: object.row.stock_adjustment_save_workplace_name,
        stock_adjustment_save_warehouse_name: object.row.stock_adjustment_save_warehouse_name,
        stock_adjustment_save_section_name: object.row.stock_adjustment_save_section_name,
        stock_adjustment_item_reason: object.row.stock_adjustment_item_reason,
        row_type: object.row.row_type,
        update_type: object.row.update_type,
      })
    }
  };

  const itemDeleteClick = (object) => {
    //재고조정 품목 삭제 버튼
    setUpdateItemRows((updateItemRows) => updateItemRows.filter((data) => data.id !== object.row.id));
    setItemRows((itemRows) => itemRows.filter((data) => data.id !== object.row.id));
    createLotRow(itemRows,object.row,'D','');
    searchLotRow(object.row, 'D');
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {

      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
      }
      
      var array = [];
      for(var i=0; i<realFiles.length; i++){
        var tmp_sever_file_name = realFiles[i].name;
        var tmp_file_name = realFiles[i].name;
        var tmp_file_size = realFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(realFiles[i].size);
        var tmp_file_type = realFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(realFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);

        array.push({
          id: newFileID,
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        })
        newFileID = newFileID + 1;
      }
      setFileRows(array);
    }
  };

  const fileDeleteClick = (object) => {
    //재고조정 파일 삭제 버튼
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }
    setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    //재고조정 파일 다운로드
  };

  const handleOnCellClick = (params) => {
    if(params.field === 'stock_adjustment_item_name' || params.field === 'stock_adjustment_item_spec'){
      setSelectModalTitle('품목 목록');
      setSelectItemModalOpen(true);
      setSelectModalType('I') // 품목 grid 에서 modal open
      setSelectItemData({
        id: params.row.id,
        stock_adjustment_item_id: params.row.stock_adjustment_item_id,
        stock_adjustment_item_name: params.row.stock_adjustment_item_name,
        stock_adjustment_item_spec: params.row.stock_adjustment_item_spec,
        stock_adjustment_item_b_stock: params.row.stock_adjustment_item_b_stock,
        stock_adjustment_item_a_stock: params.row.stock_adjustment_item_a_stock,
        stock_adjustment_item_count: params.row.stock_adjustment_item_count,
        stock_adjustment_save_workplace_id: params.row.stock_adjustment_save_workplace_id,
        stock_adjustment_save_warehouse_id: params.row.stock_adjustment_save_warehouse_id,
        stock_adjustment_save_section_id: params.row.stock_adjustment_save_section_id,
        stock_adjustment_save_workplace_name: params.row.stock_adjustment_save_workplace_name,
        stock_adjustment_save_warehouse_name: params.row.stock_adjustment_save_warehouse_name,
        stock_adjustment_save_section_name: params.row.stock_adjustment_save_section_name,
        stock_adjustment_item_reason: params.row.stock_adjustment_item_reason,
        row_type:params.row.row_type,
        update_type: params.row.update_type,
      })
    } else if(params.row.lot_stock_adjustment_item_lot_type === 'C' && (params.field === 'lot_stock_adjustment_save_workplace_name' || params.field === 'lot_stock_adjustment_save_warehouse_name' || params.field === 'lot_stock_adjustment_save_warehouse_name' || params.field === 'lot_stock_adjustment_save_section_name')){
      // 02/20 수정 // 항상 창고목록만 열음
      setSelectModalTitle('창고 목록');
      setSelectWarehouseModalOpen(true);
      setSelectModalType('L') // Lot grid 에서 modal open
      setSelectLotData({
        id: params.row.id,
        upper_id: params.row.upper_id,
        lot_no: params.row.lot_no,
        lot_stock_adjustment_item_lot_type: 'C',
        lot_stock_adjustment_item_lot_type_name: '생성',
        lot_stock_adjustment_item_id: params.row.lot_stock_adjustment_item_id,
        lot_stock_adjustment_item_name: params.row.lot_stock_adjustment_item_name,
        lot_stock_adjustment_item_spec: params.row.lot_stock_adjustment_item_spec,
        lot_stock_adjustment_save_workplace_id: params.row.lot_stock_adjustment_save_workplace_id,
        lot_stock_adjustment_save_warehouse_id: params.row.lot_stock_adjustment_save_warehouse_id,
        lot_stock_adjustment_save_section_id: params.row.lot_stock_adjustment_save_section_id,
        lot_stock_adjustment_save_workplace_name: params.row.lot_stock_adjustment_save_workplace_name,
        lot_stock_adjustment_save_warehouse_name: params.row.lot_stock_adjustment_save_warehouse_name,
        lot_stock_adjustment_save_section_name: params.row.lot_stock_adjustment_save_section_name,
        row_type: params.row.row_type,
        update_type: params.row.update_type,
      })
    }
  };
  
  const handleInputItemClick = (object) => {
    //품목 목록 모달에서 클릭한 값으로 재고조정 품목 데이터 설정함.
    let item_id = object.id
    var doubleYN = 'N'
    for(let i = 0; i < itemRows.length; i++){
      if(itemRows[i].stock_adjustment_item_id === object.id && selectItemData.id !== itemRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">품목 '+object.item_name+' 중복</p>',
        text: '추가된 품목이므로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectItemData.incoming_item_id){
        processItemRowUpdate(
          {
            id: selectItemData.id,
            stock_adjustment_item_id: object.id,
            stock_adjustment_item_name: object.item_name,
            stock_adjustment_item_spec: appStore.ITEM_FULL_SPEC_MAKE(object.item_spec, object.item_width, object.item_depth, object.item_height),
            stock_adjustment_item_count: '',
            stock_adjustment_item_b_stock: object.item_use_stock,
            stock_adjustment_item_a_stock: object.item_use_stock,
            stock_adjustment_save_workplace_id: object.item_save_workplace_id,
            stock_adjustment_save_warehouse_id: object.item_save_warehouse_id,
            stock_adjustment_save_section_id: object.item_save_section_id,
            stock_adjustment_save_workplace_name: object.item_save_workplace_name,
            stock_adjustment_save_warehouse_name: object.item_save_warehouse_name,
            stock_adjustment_save_section_name: object.item_save_section_name,
            stock_adjustment_item_reason: selectItemData.stock_adjustment_item_reason,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          },
          {
            id: selectItemData.id,
            stock_adjustment_item_id: selectItemData.stock_adjustment_item_id,
            stock_adjustment_item_name: selectItemData.stock_adjustment_item_name,
            stock_adjustment_item_spec: selectItemData.stock_adjustment_item_spec,
            stock_adjustment_item_count: selectItemData.stock_adjustment_item_count,
            stock_adjustment_item_b_stock: selectItemData.stock_adjustment_item_b_stock,
            stock_adjustment_item_a_stock: selectItemData.stock_adjustment_item_a_stock,
            stock_adjustment_save_workplace_id: selectItemData.stock_adjustment_save_workplace_id,
            stock_adjustment_save_warehouse_id: selectItemData.stock_adjustment_save_warehouse_id,
            stock_adjustment_save_section_id: selectItemData.stock_adjustment_save_section_id,
            stock_adjustment_save_workplace_name: selectItemData.stock_adjustment_save_workplace_name,
            stock_adjustment_save_warehouse_name: selectItemData.stock_adjustment_save_warehouse_name,
            stock_adjustment_save_section_name: selectItemData.stock_adjustment_save_section_name,
            stock_adjustment_item_reason: selectItemData.stock_adjustment_item_reason,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          }
        )
      }
    }
  };

  const handleWorkplaceClick = (object) => {
    //사업장 모달
    if(object.id !== selectLotData.lot_stock_adjustment_save_workplace_id){
      processLotRowUpdate(
        {
          id: selectLotData.id,
          upper_id: selectLotData.upper_id,
          lot_no: selectLotData.lot_no,
          lot_stock_adjustment_item_lot_type: selectLotData.lot_stock_adjustment_item_lot_type,
          lot_stock_adjustment_item_lot_type_name: selectLotData.lot_stock_adjustment_item_lot_type_name,
          lot_stock_adjustment_item_id: selectLotData.lot_stock_adjustment_item_id,
          lot_stock_adjustment_item_name: selectLotData.lot_stock_adjustment_item_name,
          lot_stock_adjustment_item_spec: selectLotData.lot_stock_adjustment_item_spec,
          lot_stock_adjustment_save_workplace_id: object.id,
          lot_stock_adjustment_save_warehouse_id: selectLotData.lot_stock_adjustment_save_warehouse_id,
          lot_stock_adjustment_save_section_id: selectLotData.lot_stock_adjustment_save_section_id,
          lot_stock_adjustment_save_workplace_name: object.workplace_name,
          lot_stock_adjustment_save_warehouse_name: selectLotData.lot_stock_adjustment_save_warehouse_name,
          lot_stock_adjustment_save_section_name: selectLotData.lot_stock_adjustment_save_section_name,
          row_type: selectLotData.row_type,
          update_type: selectLotData.update_type
        },
        {
          id: selectLotData.id,
          upper_id: selectLotData.upper_id,
          lot_no: selectLotData.lot_no,
          lot_stock_adjustment_item_lot_type: selectLotData.lot_stock_adjustment_item_lot_type,
          lot_stock_adjustment_item_lot_type_name: selectLotData.lot_stock_adjustment_item_lot_type_name,
          lot_stock_adjustment_item_id: selectLotData.lot_stock_adjustment_item_id,
          lot_stock_adjustment_item_name: selectLotData.lot_stock_adjustment_item_name,
          lot_stock_adjustment_item_spec: selectLotData.lot_stock_adjustment_item_spec,
          lot_stock_adjustment_save_workplace_id: selectLotData.lot_stock_adjustment_save_workplace_id,
          lot_stock_adjustment_save_warehouse_id: selectLotData.lot_stock_adjustment_save_warehouse_id,
          lot_stock_adjustment_save_section_id: selectLotData.lot_stock_adjustment_save_section_id,
          lot_stock_adjustment_save_workplace_name: selectLotData.lot_stock_adjustment_save_workplace_name,
          lot_stock_adjustment_save_warehouse_name: selectLotData.lot_stock_adjustment_save_warehouse_name,
          lot_stock_adjustment_save_section_name: selectLotData.lot_stock_adjustment_save_section_name,
          row_type: selectLotData.row_type,
          update_type: selectLotData.update_type
        }
      )
    }
  };

  const handleWarehouseClick = (object) => {
    //창고 모달
    if((object.id !== selectLotData.lot_stock_adjustment_save_warehouse_id) || object.section_cnt !== 0){
      if(object.section_cnt !== 0){ // 하위 section 정보가 있을 경우 section modal 켜줌
        setSelectModalTitle('구역 목록');
        setUpperWarehouseId(object.id);
        const nextSelectLotData = {  // 등록된 사업장/창고정보 갱신
          ...selectLotData,
          ['lot_stock_adjustment_save_workplace_id'] : object.workplace_id,
          ['lot_stock_adjustment_save_workplace_name'] : object.workplace_name,
          ['lot_stock_adjustment_save_warehouse_id'] : object.id,
          ['lot_stock_adjustment_save_warehouse_name'] : object.warehouse_name
        };
        setSelectLotData(nextSelectLotData);
        setSelectWarehouseSectionModalOpen(true);
      } else if (object.section_cnt === 0){
        processLotRowUpdate(
          {
            id: selectLotData.id,
            upper_id: selectLotData.upper_id,
            lot_no: selectLotData.lot_no,
            lot_stock_adjustment_item_lot_type: selectLotData.lot_stock_adjustment_item_lot_type,
            lot_stock_adjustment_item_lot_type_name: selectLotData.lot_stock_adjustment_item_lot_type_name,
            lot_stock_adjustment_item_id: selectLotData.lot_stock_adjustment_item_id,
            lot_stock_adjustment_item_name: selectLotData.lot_stock_adjustment_item_name,
            lot_stock_adjustment_item_spec: selectLotData.lot_stock_adjustment_item_spec,
            lot_stock_adjustment_save_workplace_id: object.workplace_id,
            lot_stock_adjustment_save_warehouse_id: object.id,
            lot_stock_adjustment_save_section_id: '',
            lot_stock_adjustment_save_workplace_name: object.workplace_name,
            lot_stock_adjustment_save_warehouse_name: object.warehouse_name,
            lot_stock_adjustment_save_section_name: '',
            row_type: selectLotData.row_type,
            update_type: selectLotData.update_type
          },
          {
            id: selectLotData.id,
            upper_id: selectLotData.upper_id,
            lot_no: selectLotData.lot_no,
            lot_stock_adjustment_item_lot_type: selectLotData.lot_stock_adjustment_item_lot_type,
            lot_stock_adjustment_item_lot_type_name: selectLotData.lot_stock_adjustment_item_lot_type_name,
            lot_stock_adjustment_item_id: selectLotData.lot_stock_adjustment_item_id,
            lot_stock_adjustment_item_name: selectLotData.lot_stock_adjustment_item_name,
            lot_stock_adjustment_item_spec: selectLotData.lot_stock_adjustment_item_spec,
            lot_stock_adjustment_save_workplace_id: selectLotData.lot_stock_adjustment_save_workplace_id,
            lot_stock_adjustment_save_warehouse_id: selectLotData.lot_stock_adjustment_save_warehouse_id,
            lot_stock_adjustment_save_section_id: selectLotData.lot_stock_adjustment_save_section_id,
            lot_stock_adjustment_save_workplace_name: selectLotData.lot_stock_adjustment_save_workplace_name,
            lot_stock_adjustment_save_warehouse_name: selectLotData.lot_stock_adjustment_save_warehouse_name,
            lot_stock_adjustment_save_section_name: selectLotData.lot_stock_adjustment_save_section_name,
            row_type: selectLotData.row_type,
            update_type: selectLotData.update_type
          }
        )
      }
    }
  };

  const handleWarehouseSectionClick = (object) => {
    //구역 모달
    if(object.id !== selectLotData.lot_stock_adjustment_save_section_id){
        processLotRowUpdate(
          {
            id: selectLotData.id,
            upper_id: selectLotData.upper_id,
            lot_no: selectLotData.lot_no,
            lot_stock_adjustment_item_lot_type: selectLotData.lot_stock_adjustment_item_lot_type,
            lot_stock_adjustment_item_lot_type_name: selectLotData.lot_stock_adjustment_item_lot_type_name,
            lot_stock_adjustment_item_id: selectLotData.lot_stock_adjustment_item_id,
            lot_stock_adjustment_item_name: selectLotData.lot_stock_adjustment_item_name,
            lot_stock_adjustment_item_spec: selectLotData.lot_stock_adjustment_item_spec,
            lot_stock_adjustment_save_workplace_id: selectLotData.lot_stock_adjustment_save_workplace_id,
            lot_stock_adjustment_save_warehouse_id: selectLotData.lot_stock_adjustment_save_warehouse_id,
            lot_stock_adjustment_save_section_id: object.id,
            lot_stock_adjustment_save_workplace_name: selectLotData.lot_stock_adjustment_save_workplace_name,
            lot_stock_adjustment_save_warehouse_name: selectLotData.lot_stock_adjustment_save_warehouse_name,
            lot_stock_adjustment_save_section_name: object.section_name,
            row_type: selectLotData.row_type,
            update_type: selectLotData.update_type
          },
          {
            id: selectLotData.id,
            upper_id: selectLotData.upper_id,
            lot_no: selectLotData.lot_no,
            lot_stock_adjustment_item_lot_type: selectLotData.lot_stock_adjustment_item_lot_type,
            lot_stock_adjustment_item_lot_type_name: selectLotData.lot_stock_adjustment_item_lot_type_name,
            lot_stock_adjustment_item_id: selectLotData.lot_stock_adjustment_item_id,
            lot_stock_adjustment_item_name: selectLotData.lot_stock_adjustment_item_name,
            lot_stock_adjustment_item_spec: selectLotData.lot_stock_adjustment_item_spec,
            lot_stock_adjustment_save_workplace_id: selectLotData.lot_stock_adjustment_save_workplace_id,
            lot_stock_adjustment_save_warehouse_id: selectLotData.lot_stock_adjustment_save_warehouse_id,
            lot_stock_adjustment_save_section_id: selectLotData.lot_stock_adjustment_save_section_id,
            lot_stock_adjustment_save_workplace_name: selectLotData.lot_stock_adjustment_save_workplace_name,
            lot_stock_adjustment_save_warehouse_name: selectLotData.lot_stock_adjustment_save_warehouse_name,
            lot_stock_adjustment_save_section_name: selectLotData.lot_stock_adjustment_save_section_name,
            row_type: selectLotData.row_type,
            update_type: selectLotData.update_type
          }
        )
        if(object.section_cnt !== 0){ // 하위 section 정보가 있을 경우 section modal 켜줌
          setSelectModalTitle('구역 목록');
          setUpperWarehouseId(object.id);
          const nextSelectItemData = {  // 등록된 사업장/창고정보 갱신
            ...selectItemData,
            ['lot_stock_adjustment_save_workplace_id'] : object.workplace_id,
            ['lot_stock_adjustment_save_workplace_name'] : object.workplace_name,
            ['lot_stock_adjustment_save_warehouse_id'] : object.id,
            ['lot_stock_adjustment_save_warehouse_name'] : object.warehouse_name
          };
          setSelectItemData(nextSelectItemData);
          setSelectWarehouseSectionModalOpen(true);
        }
      }
  };

  const handleUserClick = (object) => {
    const nextInputs = {
        ...inputs,
        ["stock_adjustment_approval_user_id"] : object.id,
        ["stock_adjustment_approval_user_name"] : object.user_name
    };
    setInputs(nextInputs);
  };

  const handleSave = (event) => {
    let msg = '';
    if((inputs.stock_adjustment_type) === '' || (inputs.stock_adjustment_type) === 0 || (inputs.stock_adjustment_type) === null){
      msg = '재고조정유형은 필수 선택 입니다.'
    }else if((inputs.stock_adjustment_date) === '' || (inputs.stock_adjustment_date) < '2025-01-01' || (inputs.stock_adjustment_date).length != 10){
      msg = '재고조정일자 입력이 올바르지 않습니다.<br/>(입력 양식 : 2025-01-01 ~ )'
    } 

    if(updateItemRows.length === 0){ // 재고조정품목이 0개 일 경우

      msg = '재고조정 품목이 존재하지 않습니다.';

    } else if(updateItemRows.length > 0 && msg === ''){ // 재고조정품목 검사
      for(let i = 0; i < updateItemRows.length; i++) {
        const stock_adjustment_item_id = updateItemRows[i].stock_adjustment_item_id;
        const stock_adjustment_item_count = updateItemRows[i].stock_adjustment_item_count;
        
        if(stock_adjustment_item_id === 0 || stock_adjustment_item_id === '') {
          msg = '선택되지 않는 재고조정 품목이 존재합니다.';
          break;
        }
        if(stock_adjustment_item_count === '' || stock_adjustment_item_count === null) {
          msg = '입력되지 않는 재고조정 수량이 존재합니다.';
          break;
        }
        if(stock_adjustment_item_count === 0) {
          msg = '변경되지 않는 재고조정 수량이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">재고조정 등록 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/p/StockAdjustment/Reg", {inputs, updateItemRows, updateLotRows} ,
      { withCredentials: true })
      .then(function (response) {
        
        if(response.status === 200){
          var selectID = response.data;
          if(updateFileRows.length > 0) {

            const formData = new FormData();
            formData.append('selectID', selectID);
            formData.append('folder', 'StockAdjustment');
            formData.append('type', 'Reg');
            formData.append('updateFileRows', JSON.stringify(updateFileRows));
            
            for(var i=0; i<realFiles.length; i++){            
              formData.append('files', realFiles[i]);
            }
            
            axios.post('/api/SaveCommon/GridFileSave'
                , formData
                , { headers: { 'Content-Type': 'multipart/form-data' } 
            }).then(response => {
              handleRegSuccessSave(selectID);
            }).catch(error => {
              appStore.capture();
            });
            
          }else{

            handleRegSuccessSave(selectID);

          }
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      })
      .finally(() => {
          appStore.setLoading(false); 
      });

    }
  };
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="재고조정 정보" value="1" />
                <Tab label="재고조정 품목" value="2" />
                <Tab label="재고조정 Lot" value="3" />
                <Tab label="재고조정 파일" value="4" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">재고조정번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="재고조정번호" value={inputs.stock_adjustment_number} name="stock_adjustment_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}  style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">재고조정유형<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <Select className="modal_filed_input_select" placeholder="재고조정유형" onChange={(e) => onSelectChange('stock_adjustment_type',e.value)} value={typeModalOption.filter(function (option) { return option.value === inputs.stock_adjustment_type;  })} options={typeModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">재고조정일자<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="date" placeholder="재고조정일자" value={inputs.stock_adjustment_date} name="stock_adjustment_date" onChange={(e) => onDateChange(e) } autoComplete="off"/>
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">재고조정승인자</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="재고조정승인자" value={inputs.stock_adjustment_approval_user_name} name="stock_adjustment_approval_user_name" onChange={(e) => onChange(e) } onClick={(e) => onClick(e) } autoComplete="off" style={{backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black', cursor: 'pointer'}} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">재고조정사유</div>
                        <div className="modal_filed_input">
                          <textarea placeholder="재고조정사유" name="stock_adjustment_reason" value={inputs.stock_adjustment_reason} onChange={(e) => onChange(e) } style={{width: '768px', height: '200px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off">
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={itemRows}
                  columns={itemColumns}
                  columnVisibilityModel={itemColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processItemRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={lotRows}
                  columns={lotColumns}
                  columnVisibilityModel={lotColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processLotRowUpdate}
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'       
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    <div className="modal_button">
                      {MenuUpdateYN === 'Y' &&
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                      </Button> }
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectItemModalOpen && (<ItemSelectModal
          onClose={() => {
              setSelectItemModalOpen(false);
          }}
          title={selectmodalTitle}
          handleInputItemClick={handleInputItemClick}
          />)}

        {isSelectWorkplaceModalOpen && (<WorkplaceSelectModal
          onClose={() => {
              setSelectWorkplaceModalOpen(false);
          }}
          title={selectmodalTitle}
          handleWorkplaceClick={handleWorkplaceClick}
          />)}

        {isSelectWarehouseModalOpen && (<WarehouseSelectModal
            onClose={() => {
                setSelectWarehouseModalOpen(false);
            }}
            title={selectmodalTitle}
            upperWorkplaceId={upperWorkplaceId}
            handleWarehouseClick={handleWarehouseClick}
            />)}

        {isSelectWarehouseSectionModalOpen && (<WarehouseSectionSelectModal
            onClose={() => {
                setSelectWarehouseSectionModalOpen(false);
            }}
            title={selectmodalTitle}
            upperWarehouseId={upperWarehouseId}
            handleWarehouseSectionClick={handleWarehouseSectionClick}
            />)}
        {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
    </PCModal>
  );
}

export default StockAdjustmentRegModal;